import { Route as PublicRoute } from 'react-router-dom';

import { PATH_NAME } from '../pathNames';
import { AssessmentQuery } from '../lazyLoaded';

const AssessmentQueryRoute = () => (
  <PublicRoute
    exact
    path={PATH_NAME.ASSESSMENT_QUERY}
    component={(props: JSX.IntrinsicAttributes) => (
      <AssessmentQuery {...props} />
    )}
  />
);
export default AssessmentQueryRoute;
